import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './Requirements.module.css';

const items = [
  {
    id: 'credentials',
    titleId: 'ForProvidersRequirements.credentialsTitle',
    title: 'Credentials',
    textId: 'ForProvidersRequirements.credentialsText',
    text: 'Any licenses, certifications, or training that apply to your work.',
  },
  {
    id: 'background',
    titleId: 'ForProvidersRequirements.backgroundTitle',
    title: 'Background check consent',
    textId: 'ForProvidersRequirements.backgroundText',
    text:
      "Required for providers who work in families' homes, like postpartum doulas and newborn care specialists.",
  },
  {
    id: 'services',
    titleId: 'ForProvidersRequirements.servicesTitle',
    title: 'Your service details',
    textId: 'ForProvidersRequirements.servicesText',
    text:
      'What you offer, your rates, availability, where you work, and whether you see families in-home, in-office, or virtually.',
  },
  {
    id: 'profile',
    titleId: 'ForProvidersRequirements.profileTitle',
    title: 'A professional profile',
    textId: 'ForProvidersRequirements.profileText',
    text:
      'Your experience, your approach to care, and a clear photo so families can get to know you.',
  },
];

/**
 * What a provider should have ready before applying.
 */
const Requirements = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <div className={css.copy}>
        <p className={css.eyebrow}>
          <FormattedMessage
            id="ForProvidersRequirements.eyebrow"
            defaultMessage="Before you apply"
          />
        </p>
        <h2 className={css.title}>
          <FormattedMessage
            id="ForProvidersRequirements.title"
            defaultMessage="What you'll need to join"
          />
        </h2>
      </div>
      <ul className={css.list}>
        {items.map(item => (
          <li key={item.id} className={css.item}>
            <svg className={css.mark} viewBox="0 0 20 20" aria-hidden="true">
              <path
                d="M4.5 10.5 8.2 14.2 15.5 6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>
              <p className={css.itemTitle}>
                <FormattedMessage id={item.titleId} defaultMessage={item.title} />
              </p>
              <p className={css.itemText}>
                <FormattedMessage id={item.textId} defaultMessage={item.text} />
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Requirements;
